import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    IconButton,
    Grid, Box
} from '@mui/material'
import {ReactComponent as CloseIcon} from "src/v2/assets/icons/close-icon.svg"
import ButtonWithIcon from "../../../../components/Button/Button"
import TextFieldInput from "../../../../components/Input/text-field-input"
import {ReactComponent as ArrowRightIcon} from "src/v2/assets/icons/arrow-right-icon.svg"
import CetipVersaoFilterComponent from "../CetipVersaoFilter/cetip-versao-filter-component"
import CetipVersaoEventosFilterComponent from "../CetipVersaoFilter/cetip-versao-eventos-filter-component"

const DuplicarModal = ({open, onClose, onConfirm, rowOriginal, autoComplete, autoCompleteEventos}) => {
    const [novoCetip, setNovoCetip] = useState('')
    const [novaVersao, setNovaVersao] = useState('')
    const desabilitado = !novoCetip || !novaVersao

    const handleConfirmar = () => {
        const payloadProximaTela = {
            original: rowOriginal,
            novoCetip: novoCetip,
            novaVersao: novaVersao
        }
        onConfirm(payloadProximaTela)
        limparEFechar()
    }

    const limparEFechar = () => {
        setNovoCetip('')
        setNovaVersao('')
        onClose()
    }

    return (
        <Dialog
            open={open}
            onClose={limparEFechar}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: 'background.paper',
                    color: 'common.white'
                }
            }}
        >
            <DialogTitle sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '24px 24px 0 24px'
            }}>
                <Typography variant="h3" sx={{color: 'common.white', lineHeight: '37px'}}>
                    Duplicar
                </Typography>
                <IconButton onClick={limparEFechar} sx={{color: 'icon.main'}}>
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{mt: 2, paddingBottom: 0, overflow: 'visible'}}>
                <Typography variant="body2" sx={{mb: 3, color: 'input.label.secondary'}}>
                    Informe a CETIP e Versão do novo Documento:
                </Typography>

                {autoComplete ?
                    <CetipVersaoFilterComponent
                        disableButtons
                        setCetip={setNovoCetip}
                        setVersao={setNovaVersao}
                        returnCetipVersao={(cetipReturned, versaoReturned) => {
                            setNovoCetip(cetipReturned)
                            setNovaVersao(versaoReturned)
                        }}
                    /> :
                        autoCompleteEventos ?
                        <CetipVersaoEventosFilterComponent
                        disableButtons
                        setCetip={setNovoCetip}
                        setVersao={setNovaVersao}
                        returnCetipVersao={(cetipReturned, versaoReturned) => {
                            setNovoCetip(cetipReturned)
                            setNovaVersao(versaoReturned)
                        }}
                    /> :
                    <Box sx={{width: '100%'}}>
                        <Grid container direction={"row"} spacing={2}>
                            <Grid item xs={6} md={6} xl={6}>
                                <TextFieldInput
                                    fullWidth
                                    label="CETIP"
                                    value={novoCetip}
                                    onChange={(e) => setNovoCetip(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6} md={6} xl={6}>
                                <TextFieldInput
                                    fullWidth
                                    label="Versão documento"
                                    value={novaVersao}
                                    onChange={(e) => setNovaVersao(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                }
            </DialogContent>

            <DialogActions sx={{padding: "24px", justifyContent: 'flex-end'}}>
                <ButtonWithIcon
                    onClick={handleConfirmar}
                    disabled={desabilitado}
                    startIcon={<ArrowRightIcon/>}
                    sx={{
                        width: '140px',
                        height: '36px',
                        borderRadius: '40px',
                        border: '1px solid',
                        padding: 0,
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',

                        borderColor: 'input.borderColor.white70',
                        color: 'common.white',

                        '& .MuiButton-startIcon': {
                            color: 'icon.main'
                        },

                        '&:hover': {
                            backgroundColor: 'transparent.white10'
                        },

                        '&.Mui-disabled': {
                            color: 'icon.disabled',
                        }
                    }}
                >
                    CADASTRAR
                </ButtonWithIcon>
            </DialogActions>
        </Dialog>
    )
}

DuplicarModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    rowOriginal: PropTypes.object,
    autoComplete: PropTypes.bool,
    autoCompleteEventos: PropTypes.bool
}

export default DuplicarModal